export enum SortTable {
  ASC = 'asc',
  DESC = 'desc',
}
